import axios from 'axios';
var convert = require('xml-js');
var grid_data = [];
// Excel Portion Starts
function upload (_this,file) {
    var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (regex.test(file.name.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();
                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                            //var edata = this.ProcessExcel(e.target.result);
                             //Read all rows from First Sheet into an JSON array.
                           _this.stockitem_Exceldata = get_header_row(e.target.result);
                          _this.Headers = _this.stockitem_Exceldata;
                          _this.columns = _this.Headers;
                          _this.dataSource = grid_data;
                          _this.IsVisible = true;
                          _this.hlen = Headers.length;
                    };
                    reader.readAsBinaryString(file);
                } else {
                    //For IE Browser.
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        var edata = $scope.ProcessExcel(data);
                        $scope.$apply(function () {
                            $scope.Customers = edata;
                            $scope.Headers = Object.keys(edata[0]);
                            $scope.IsVisible = true;
                            $scope.hlen = $scope.Headers.length;
                        });
                    };
                    reader.readAsArrayBuffer($scope.SelectedFile);
                }
            } else {
                $window.alert("This browser does not support HTML5.");
            }
        } else {
            $window.alert("Please upload a valid Excel file.");
        }
};

//get ledger sheet headers
function get_header_row(data) {
    
    var grid_data_obj = {};
    var XLSX = require('xlsx');

    var workbook = XLSX.read(data, {
       type: 'binary'
    });
    
    var headers = [];
    var range = XLSX.utils.decode_range(workbook.Sheets.Sheet1['!ref']);
    var C, R = range.s.r; /* start in the first row */
    /* walk every column in the range */
    for (C = range.s.c; C <= range.e.c; ++C) {
       var cell = workbook.Sheets.Sheet1[XLSX.utils.encode_cell({ c: C, r: R })] /* find the cell in the first row */
       var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
       if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
       headers.push(hdr);
    }
    
    for (C = range.s.c; C <= range.e.c; ++C) {
        var cell = workbook.Sheets.Sheet1[XLSX.utils.encode_cell({ c: C, r: R })] /* find the cell in the first row */
        var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        grid_data_obj[hdr] = hdr;
     }
    
     grid_data.push(grid_data_obj);
     
      return grid_data;
 }

 //get company names
 function getCompanyNames(_this,meta) {
    if(meta=="electron"){
        window.api.send('getCompanyNames_tally'); 
        window.api.receive("fromMain", (company_obj) => {
            $.each(company_obj,function(key,value){
                _this.company_names = [];
                _this.company_names.push(value);
               // $(".company_name").append("<option value=" + value + ">" + value + "</value>");
            })
        }); 
    }
    else{
        axios.get('fetchCompanyNames')
        .then((result) => {
            var companies = [];
            var company_obj = JSON.parse(convert.xml2json(result.data, { compact: true, spaces: 4 }));
            var key = '';
            getCompanyName([company_obj], key,_this);
        });
    }
}
 
 
 function getCompanyName(arr, key) {
     if (arr) {
         arr.forEach(element => {
             if (Array.isArray(element) == true) {
                 var Keys = '';
                 getCompanyName(element, Keys);
             }
             else if (typeof element == 'object') {
                 //var values = Object.values( element );
                 var keys = Object.keys(element);
                 var vals = Object.keys(element).map(function (key) {
                     return element[key];
                 });
                 if (keys.includes("_text") == true) {
                     // console.log(element.LEDGER._attributes.NAME);
                     //arrVchType.push(element.VOUCHERTYPE._attributes.NAME)
                     $(".company_name").append("<option value=" + element._text + ">" + element._text + "</value>");
                 }
                 else {
                     getCompanyName(vals);
                 }
             }
         });
     }
 }

 //save json to db
 function saveJson(url,params){
    axios.post(url,params)
         .then((response)=>{alert('template_saved')});
}

 export {upload,getCompanyNames,saveJson}